var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppStatusBarSuccessImtokenDark = function SvgAppStatusBarSuccessImtokenDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#app-statusBar-success-imtoken-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "app-statusBar-success-imtoken-dark_svg__b",
    width: 311,
    height: 12,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M311 0H0v12h311z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#app-statusBar-success-imtoken-dark_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#007FFF",
    fillOpacity: 0.8,
    d: "M305 0H6a6 6 0 1 0 0 12h299a6 6 0 1 0 0-12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 2,
    d: "M9 6a3 3 0 1 0-6 0 3 3 0 0 0 6 0ZM159 6a3 3 0 1 0-6 0 3 3 0 0 0 6 0ZM308 6a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "app-statusBar-success-imtoken-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h311v12H0z"
  })))));
};
export { SvgAppStatusBarSuccessImtokenDark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzExIiBoZWlnaHQ9IjEyIiB2aWV3Qm94PSIwIDAgMzExIDEyIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTcxNF8xOTUzNykiPgo8bWFzayBpZD0ibWFzazBfMTcxNF8xOTUzNyIgc3R5bGU9Im1hc2stdHlwZTpsdW1pbmFuY2UiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIzMTEiIGhlaWdodD0iMTIiPgo8cGF0aCBkPSJNMzExIDBIMFYxMkgzMTFWMFoiIGZpbGw9IndoaXRlIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNtYXNrMF8xNzE0XzE5NTM3KSI+CjxwYXRoIGQ9Ik0zMDUgMEg2QzIuNjg2MjkgMCAwIDIuNjg2MjkgMCA2QzAgOS4zMTM3MSAyLjY4NjI5IDEyIDYgMTJIMzA1QzMwOC4zMTQgMTIgMzExIDkuMzEzNzEgMzExIDZDMzExIDIuNjg2MjkgMzA4LjMxNCAwIDMwNSAwWiIgZmlsbD0iIzAwN0ZGRiIgZmlsbC1vcGFjaXR5PSIwLjgiLz4KPHBhdGggZD0iTTkgNkM5IDQuMzQzMTUgNy42NTY4NSAzIDYgM0M0LjM0MzE1IDMgMyA0LjM0MzE1IDMgNkMzIDcuNjU2ODUgNC4zNDMxNSA5IDYgOUM3LjY1Njg1IDkgOSA3LjY1Njg1IDkgNloiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMTU5IDZDMTU5IDQuMzQzMTUgMTU3LjY1NyAzIDE1NiAzQzE1NC4zNDMgMyAxNTMgNC4zNDMxNSAxNTMgNkMxNTMgNy42NTY4NSAxNTQuMzQzIDkgMTU2IDlDMTU3LjY1NyA5IDE1OSA3LjY1Njg1IDE1OSA2WiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zMDggNkMzMDggNC4zNDMxNSAzMDYuNjU3IDMgMzA1IDNDMzAzLjM0MyAzIDMwMiA0LjM0MzE1IDMwMiA2QzMwMiA3LjY1Njg1IDMwMy4zNDMgOSAzMDUgOUMzMDYuNjU3IDkgMzA4IDcuNjU2ODUgMzA4IDZaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPC9nPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE3MTRfMTk1MzciPgo8cmVjdCB3aWR0aD0iMzExIiBoZWlnaHQ9IjEyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";